import { str } from "./str.js";
import { num } from "./num.js";
import { table } from "./table.js";
import { any } from "./any.js";
import { obj } from "./obj.js";
import { defaultLoader, defaultLoaderItem, loaders, } from "./loaders.js";
export const slice = {
    str,
    num,
    table,
    any,
    obj,
    loaders,
    /**
     * @deprecated Use `slice.loaders` instead
     */
    loader: loaders,
};
export { defaultLoader, defaultLoaderItem };
//# sourceMappingURL=mod.js.map